import { createContext, useContext } from 'react'

const LocationContext = createContext()

export default LocationContext

export const useLocationContext = () => {
    return useContext(LocationContext)
}
